<template>
  <div id="login">
    <div class="left-column"></div>
    <div class="right-column">
      <div class="column-content">
        <div class="title">
          <h1>{{$t('login.profiles')}}<br><span>{{$t('login.byMobivia')}}</span></h1>
        </div>
        <div v-if="lastErrorCode" class="wrongAuthentification">
          {{$t('login.unauthorizedEmail')}}
        </div>
        <button v-google-signin-button="client_id" class="btn-google">
          <div class="icon google"></div>
          <span>{{$t('login.googleConnect')}}</span>
        </button>
        <form>
          <header>
            <div></div>
            <span>{{$t('login.or')}}</span>
            <div></div>
          </header>
          <div class="content">
            <div class="title">{{$t('login.forAtu')}}</div>
            <div class="wrongAuthentification">{{wrongAuthentificationMessage}}</div>
            <input type="text" name="username" v-bind:placeholder="$t('login.username')" v-model="username" v-on:keyup.enter="onSubmit" class="atuUsername">
            <input type="password" name="password" v-bind:placeholder="$t('login.password')" v-model="password" v-on:keyup.enter="onSubmit" class="atuPassword">
            <div class="remember">
              <input type="checkbox" name="remember" class="rememberMe">
              <label for="remember">{{$t('login.rememberMe')}}</label>
            </div>
          </div>
          <footer>
            <router-link to="/">
              <div class="btn submit" @click="onSubmit">{{$t('login.login')}}</div>
            </router-link>
          </footer>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import GoogleSignInButton from 'vue-google-signin-button-directive'
import jwtDecode from 'jwt-decode'
import axios from 'axios'

export default {
  name: 'login',
  directives: {
    GoogleSignInButton
  },
  components: {

  },
  data() {
    return {
      // change client id with yours
      client_id: '500054702866-ml4nivm37g975mj5c4u86olrotuq4p5b.apps.googleusercontent.com',
      username: localStorage.savedMail,
      password: null,
      wrongAuthentificationMessage: '',
      lastErrorCode: this.$route.query.lastErrorCode,
    }
  },
  computed: {
  },
  mounted() {
    this.$nextTick(function () {
      let rememberMe = localStorage.rememberMe
      if(rememberMe === 'true') {
        document.getElementsByClassName('rememberMe')[0].checked = true
        let jwtToken = localStorage.jwtToken
        if(jwtToken) {
          try{
            let decodedToken = jwtDecode(jwtToken)
            this.connectWithSavedToken(jwtToken, decodedToken);
          }catch{
            console.error('Jwt token invalide !')
          }
        }
      }
    })
  },
  methods: {
    connectWithSavedToken(jwtToken, decodedToken) {
      this.commitUserOnStore(jwtToken, decodedToken)
      this.validateToken()
    },
    validateToken() {
      axios.get(this.$store.state.user.url + '/validateToken', {headers: {'Authorization': 'Bearer ' + this.$store.state.user.token}})
      .then(() => {
        this.$router.push('/')
      })
      .catch(err => {
        console.error(err)
        localStorage.removeItem('jwtToken')
        this.$router.push(
          {name: 'login'}
        )
      })
    },
    onSubmit() {
      let auth = {
        mail: this.username,
        password: this.password
      };

      let url = this.$store.state.user.url + '/atuAuthenticate';
      let responseToken;

      axios.post(url, auth)
      .then((response) => {
        responseToken = response.data.result
        let decoded = jwtDecode(responseToken)
        this.commitUserOnStore(responseToken, decoded)
      }).then(() => {
        if(document.getElementsByClassName("rememberMe")[0].checked) {
          localStorage.jwtToken = responseToken
          localStorage.savedMail = document.getElementsByClassName('atuUsername')[0].value
          localStorage.rememberMe = true
        }else{
          localStorage.rememberMe = false
          localStorage.removeItem('savedMail')
        }
        this.$router.push('/')
      })
      .catch(error => {
        this.wrongAuthentificationMessage = this.$t('login.wrongAuthentificationMessage');
        this.password = null
        console.log(error)
      })

    },
    OnGoogleAuthSuccess (idToken) {
      let decoded = jwtDecode(idToken)
      this.commitUserOnStore(idToken, decoded)
      this.$router.push('/')
    },
    OnGoogleAuthFail (error) {
      console.log(error)
    },
    commitUserOnStore(jwtToken, decodedToken){
      this.$store.commit('setUser', {
        id: decodedToken,
        email: '',
        name: '',
        token: jwtToken
      })
    },
  }
}
</script>

<style lang="scss" scoped>
  @import "@/assets/styles/login.sass"
</style>
